import Menus from "@/components/menus/Menus";
import Pagination from "@/components/pagination/Pagination";
import { getMenus } from "@/services/menuService";
import { MenuJsonItem } from "@/types/types";
import { capitalizeText } from "@/utilities/menu";
import Head from "next/head";

interface PageProps {
  menus: MenuJsonItem[];
  location: string;
  country: string;
  currentPage: number;
  totalPages: number;
}

export async function getServerSideProps(
  context: any
): Promise<{ props?: PageProps; notFound?: boolean; redirect?: any }> {
  const { params, page = 1, limit = 51 } = context.query;

  let country = params?.[0] || "";
  let city = params?.[1] || "";

  if (country === "cuisine") {
    return {
      redirect: {
        destination: "/restaurants",
        permanent: false,
      },
    };
  }

  country = country.replace(/ /g, "  ").replace(/-/g, " ").toLocaleLowerCase(); // this is required
  city = city.replace(/ /g, "  ").replace(/-/g, " ").toLocaleLowerCase();

  let response = await getMenus(
    "",
    parseInt(page),
    parseInt(limit),
    country,
    city,
    undefined
  );

  // Set location for props based on city or country
  const locationText = city ? capitalizeText(city) : capitalizeText(country);

  return {
    props: {
      menus: response.data,
      location: locationText,
      country: capitalizeText(country),
      currentPage: response.currentPage,
      totalPages: response.totalPages,
    },
  };
}

const MenusPage: React.FC<PageProps> = ({
  menus,
  location,
  country,
  currentPage,
  totalPages,
}) => {
  return (
    <div>
      <Head>
        <title>
          {`The Best Restaurants in ${location} Right Now | Qr menu`}
        </title>
        <meta
          name="description"
          content={`Explore the top restaurants in ${location}. We provide latest menu and price information for the leading restaurants menu price in ${location}.`}
        />
      </Head>
      <div
        className="bg-cover bg-center min-h-[35vh] flex items-center justify-center py-20"
        style={{
          backgroundImage: `url('https://dopweb-repository.s3.us-west-2.amazonaws.com/qrmenu/mydop-images/img5d5db67a-221c-4e9d-87fb-f2d56bd9a51e.webp')`,
        }}
      >
        <div className="container mx-auto text-center">
          <div className="flex flex-wrap justify-center">
            <div className="w-full px-4">
              <h1 className="text-4xl font-bold text-black mb-4">
                The best restaurants in {location}
              </h1>
              <p className="text-xl text-black">
                Explore the Best Menu Selections of {location} Restaurants
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mb-12 max-w-[1225px]">
        <h2 className="text-2xl font-semibold text-center my-8">
          Browse restaurant menus in {location}
          {location !== country ? `, ${country}` : ""}
        </h2>
        <Menus menus={menus} />
        <Pagination currentPage={currentPage} totalPages={totalPages} />
      </div>
    </div>
  );
};

export default MenusPage;
